export default __webpack_public_path__ + "static/media/70t.bef50388.jpg";